export function usePage() {
  const page = useContentStore().page
  if (!page) throw new Error('Page not loaded')
  return page
}
